import React, { useRef, useState, useEffect } from "react";
import { Avatar, Button, TextField, Link, Grid, Typography, CircularProgress, FormControlLabel, Checkbox } from '@material-ui/core/';
import LockOutlinedIcon from '@material-ui/icons/LockOutlined';
import { useTranslation } from "react-i18next";
import { Link as RouterLink, Redirect } from "react-router-dom";
import Alert from "@material-ui/lab/Alert";
import Cookies from 'universal-cookie';

import { repliValidator } from "../../../components";
import CryptoJS from 'crypto-js'

import useStyles from "./Login.style";

const cookies = new Cookies();

const LoginTextField = props => {
    return <TextField
        variant="outlined"
        margin="normal"
        required
        fullWidth
        {...props}
    />
}

const Login = () => {
    const classes = useStyles();
    const { t } = useTranslation();

    const [error, setError] = useState('');
    const [submitted, setSubmitted] = useState(false);
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [sending, setSending] = useState(false);
    const [isAuthenticated, setisAuthenticated] = useState(false);
    const [is2fauthentication, set2fauthentication] = useState(false);
    const [rememberMe, setRememberMe] = useState(false);


    const validator = useRef(repliValidator());

    useEffect(() => {
        const storedEmail = cookies.get("email");
        const storedPassword = cookies.get("password");
        const storedRememberMe = cookies.get("rememberMe")
    
        if (storedEmail && storedPassword && storedRememberMe) {
          setEmail(
            CryptoJS.AES.decrypt(
              storedEmail,
              process.env.REACT_APP_SECRET_KEY
            ).toString(CryptoJS.enc.Utf8)
          );
          setPassword(
            CryptoJS.AES.decrypt(
              storedPassword,
              process.env.REACT_APP_SECRET_KEY
            ).toString(CryptoJS.enc.Utf8)
          );
          setRememberMe(storedRememberMe); 
        }
    
      }, []);

    const handleSubmit = async e => {
        e.preventDefault();
        setSubmitted(true);

        const isValid = validator.current.allValid();
        if (!isValid) {
            validator.current.showMessages();
            return;
        }

        setSending(true);
        try {
            let response = await fetch(`${process.env.REACT_APP_API_URL}/${process.env.REACT_APP_API_PROVIDER_AUTH_SIGNIN}`, {
                method: 'post',
                body: new URLSearchParams({
                    email: email,
                    password: password,
                })
            });
            if (!response.ok) {
                let json = await response.json();
                
                json.message === "Your Organization is not active" ? setError("Your Organization is not active. Please contact administrator.") : setError(json.message);
                return;
            };
            let json = await response.json();

            set2fauthentication(json.is2FAEnabled);

            const encryptEmail = CryptoJS.AES.encrypt(
                CryptoJS.enc.Utf8.parse(json.email),
                process.env.REACT_APP_SECRET_KEY
              ).toString();

            const encryptPassword = CryptoJS.AES.encrypt(
                CryptoJS.enc.Utf8.parse(password),
                process.env.REACT_APP_SECRET_KEY
              ).toString();
       
              if (rememberMe) {
                cookies.set("email", encryptEmail, { path: "/"});
                cookies.set("password", encryptPassword, { path: "/"});
                cookies.set("rememberMe", rememberMe, { path: "/"});
              } else {
                cookies.remove("email", { path: "/"});
                cookies.remove("password",  { path: "/"});
                cookies.remove("rememberMe",  { path: "/"});
              }
            localStorage.setItem('email', encryptEmail);
            localStorage.setItem('is2FAEnabled', json.is2FAEnabled)
            localStorage.setItem('isProvider', json.isProvider)
            localStorage.setItem('isPatientSignIn', 'false')
            setisAuthenticated(true);
        } catch (error) {
            console.log(error.message);
            setError(t('signIn.errorMessage'));
        } finally {
            setSending(false);
        };
    };

    if (!is2fauthentication && isAuthenticated) return <Redirect to='/app/authentication'></Redirect>;

    if (is2fauthentication && isAuthenticated) return <Redirect to='/app/otpverification'></Redirect>;


    return (
        <div className={classes.paper}>
            <Avatar className={classes.avatar}>
                <LockOutlinedIcon />
            </Avatar>
            <Typography component="h1" variant="h5">
                {t('signIn.buttonLabels.signIn')}
            </Typography>
            <form className={classes.form} noValidate onSubmit={handleSubmit}>
                <LoginTextField
                    label={t('common.form.label.email')}
                    name="email"
                    autoComplete="email"
                    autoFocus
                    error={submitted && !validator.current.fieldValid('email')}
                    helperText={validator.current.message('email', email, 'required|email')}
                    onChange={e => setEmail(e.target.value.trim())}
                    value={email}
                />
                <LoginTextField
                    name="password"
                    label={t('common.form.label.password')}
                    type="password"
                    id="password"
                    autoComplete="current-password"
                    error={submitted && !validator.current.fieldValid('password')}
                    helperText={validator.current.message('password', password, 'required|min:8')}
                    onChange={e => setPassword(e.target.value.trim())}
                    value={password}
                />
                {
                    error &&
                    <Alert severity="error">{error}</Alert>
                }

                <FormControlLabel
                    control={
                        <Checkbox
                            checked={rememberMe}
                            onChange={e => setRememberMe(e.target.checked)}
                            color="primary"
                        />
                    }
                    label={t('common.form.label.rememberMe')} 
                />
                <Button
                    type="submit"
                    fullWidth
                    variant="contained"
                    color="primary"
                    className={classes.submit}
                    disabled={sending}
                >
                    {t('signIn.buttonLabels.signIn')}
                    {sending && <CircularProgress size={24} className={classes.buttonProgress} />}
                </Button>
                <Grid container>
                    <Grid item xs={12}>
                        <Link component={RouterLink} to="/provider/login/pwdrecovery">
                            {t('signIn.links.forgotPassword')}
                        </Link>
                    </Grid>
                    <Grid item xs>
                        <Link component={RouterLink} to="/provider/login/tokenresend">
                            {t('signIn.links.tokenResend')}
                        </Link>
                    </Grid>
                </Grid>
            </form>
        </div>
    )
};

export default Login;